import SidebarAndContainer from '../../../components/sidebar-and-container/sidebar-and-container.component';

import * as Unicons from '@iconscout/react-unicons';
import { Fragment, useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Title from '../../../components/title/title.component';
import { useGlobalContext } from '../../../context/GlobalContext';
import {
  IMaterialApoioDTO,
  IPastaDTO
} from '../../../models/happy-code-api.model';
import { Predicate } from '../../../models/predicate.model';
import { useMaterialApoioService } from '../../../services/materiais.apoio.service';
import { ArquivoContainer } from './components/ArquivoContainer';
import FiltrosArquivo from './components/ArquivoContainer/arquivosFiltros';
import { usePastaService } from '../../../services/pasta.service';
import { PastaContainer } from '../pasta/components/PastaContainer';
import { useTranslation } from 'react-i18next';

export default function ArquivosMaterialApoio() {
  const [data, setData] = useState<IMaterialApoioDTO[]>();
  const [subPastas, setSubPastas] = useState<IPastaDTO[]>();
  const [pasta, setPasta] = useState<IPastaDTO>();
  const [predicate] = useState<Predicate>(new Predicate());
  const { setIsGlobalLoading } = useGlobalContext();
  const { idPasta } = useParams<any>();
  const navigate = useNavigate();
  const materialApoioService = useMaterialApoioService();
  const pastaService = usePastaService();
  const { t } = useTranslation(['common', 'materiais_de_apoio']);

  const fetchMaterialDeApoio = () => {
    predicate.addOption('pasta.id', idPasta);
    predicate.addOption('ativo', true);
    predicate.size = 12;
    materialApoioService
      .findCustom(predicate)
      .then((response) => {
        setData(response.data);
      })
  };

  const fechSubpastas = async () => {
    const predicatePasta = new Predicate();
    predicatePasta.addOption('pastaPai.id', idPasta);
    predicatePasta.addOption('ativo', true);
    pastaService
      .findList(predicatePasta)
      .then(({ data }) => {
        setSubPastas(data);
      })
  };

  const fetchPasta = async () => {
    pastaService
      .findById({ id: Number(idPasta) })
      .then(({ data }) => {
        setPasta(data);
      })
  };

  useEffect(() => {
    setIsGlobalLoading(true);
    Promise.all([fetchMaterialDeApoio(), fechSubpastas(), fetchPasta()]).finally(() => setIsGlobalLoading(false));
  }, [idPasta])

  return (
    <SidebarAndContainer materiaisApoio={true}>
      <Fragment>
        <div className="webinars-all-container__title-back-button">
          <button className="button-second" onClick={() => navigate(-1)}>
            <Unicons.UilArrowLeft />
            {t('common:back')}
          </button>
            <Title title={`${pasta?.nome ?? ''} (${(data?.length ?? 0) + (subPastas?.length ?? 0)})`} />
        </div>
        <div className="webinars-all-container__search-bar">
          <FiltrosArquivo t={t} fetchMaterialDeApoio={fetchMaterialDeApoio} predicate={predicate} />
        </div>
        <div className="webinars-all-container__webinars-cards">
          {subPastas?.map((pasta) => (
            <PastaContainer key={pasta.id} Pasta={pasta} />
          ))}
        </div>
        <div className="webinars-all-container__webinars-cards">
          {data?.map((MaterialApoio) => <ArquivoContainer MaterialApoio={MaterialApoio} />)}
        </div>
      </Fragment>
    </SidebarAndContainer>
  );
}
